module.exports = __webpack_public_path__ + "static/media/imagenparte1.11ea5e76.svg";